import React, { useEffect } from "react";
import { Button, Form, Input, DatePicker, Select, TreeSelect } from "antd";
import { useModel } from "../../../models/index";

const { RangePicker } = DatePicker;
const rangeConfig = {
    rules: [{ type: 'array', required: false, message: '请选择制单时间!' }],
};
export default function () {
    const [form] = Form.useForm();

    const [{ materialSortDict, customerDict }] = useModel("cmDict");
    const [{ searchParam, searcnPage }, { setSearchParam, resetSearchParam, loadListDetail }] = useModel("partDealModel");

    useEffect(() => {
        form.resetFields();
        resetSearchParam();
        // onReset();
    }, []);
    // useEffect(() => {
    //     form.setFieldsValue(searchParam);
    // }, [searchParam]);

    const onFinish = () => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { pageSize, pageNum } = searcnPage
        const { materialCode, customerName, category,materialName } = searchParam;
        let data = {
            startTime,
            endTime,
            pageSize,
            pageNum,
            materialCode, // "商品编号"
            materialName,//商品名称
            customerName, //  "客户名称"            
            category, // "商品类型 "
        }
        loadListDetail({ showMsg: true, data });
    }
    const onReset = () => {
        form.resetFields();
        resetSearchParam();
        let data = {
            pageSize: 15,
            pageNum: 1,
        }
        loadListDetail({ showMsg: true, data })
    }
    return (
        <Form
            form={form}
            layout="inline"
            onFinish={onFinish}
            onValuesChange={e => setSearchParam(e)}
        >
            <Form.Item
                name="materialCode"
                label="商品编号"
            >
                <Input placeholder="商品编号" style={{ width: "200px",marginBottom:"20px" }} />
            </Form.Item>
            <Form.Item
                name="materialName"
                label="商品名称"
            >
                <Input placeholder="商品名称" style={{ width: "200px",marginBottom:"20px" }} />
            </Form.Item>
            <Form.Item
                name="customerName"
                label="客户名称"
            >
                <Select
                    style={{ width: "200px" }}
                    showSearch
                    allowClear={true}
                    placeholder="选择客户"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={customerDict}
                    dropdownClassName="dark-select"
                />
            </Form.Item>
            <Form.Item
                style={{ marginBottom: 0, width: 300 }}
                name="category"
                label="商品类型"
            >
                <TreeSelect
                    showSearch
                    allowClear
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder="请选择商品类型"
                    treeDefaultExpandAll
                    onChange={() => {
                    }}
                    treeData={materialSortDict}
                />
            </Form.Item>
            <Form.Item name="checkTime" label="制单日期" {...rangeConfig}>
                <RangePicker style={{ width: "300px" }} />
            </Form.Item>
            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="button"
                            className="margin-left-8"
                            onClick={onReset}
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );
}